export const HAPPENING = 'happening';
export const UPCOMING = 'upcoming';

export type SessionGroup = typeof HAPPENING | typeof UPCOMING;

export type SubTrack = {
  id: string;
  name: string;
  order: number;
};

export type Track = SubTrack & {
  color: string;
  subTracks: SubTrack[];
};

export type Session = {
  id: string;
  name: string;
  description: string;
  startDatetime: string;
  endDatetime: string;
  // TODO: Make a separate type in types folder if used multiple places
  location: {
    label: string;
  };
  tracks: Track[];
  group: SessionGroup;
};
